export default new VueRouter({
    routes: [{
        path: '/',
        name: '',
        meta: {
            title: '首页_安徽省大易科技有限公司'
        }
    }]
})
